import React, { useCallback, useState } from 'react';
import Rezervacije from './Rezervacije';
import { useOsvezavanje } from '../osvezavanje';
import { api } from '../services/api';
import { RezervacijaRadnja, RezervacijePregled } from '../types';

/** Osvežava se na minut: alarm stiže porukom, a ekran ne sme da zaostane za njom. */
const OSVEZI_MS = 60_000;

/**
 * Kartica „Rezervacije za kupce" za šefa magacina — svi objekti. Do nje vodi i
 * link iz Viber poruke (`?ekran=rezervacije`), pa mora da radi i na telefonu.
 */
export default function RezervacijeEkran() {
  const [pregled, setPregled] = useState<RezervacijePregled | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [zauzeto, setZauzeto] = useState(false);

  const load = useCallback(async () => {
    try {
      setPregled(await api.rezervacije());
      setError(null);
    } catch (e) {
      setError(e instanceof Error ? e.message : String(e));
    }
  }, []);

  useOsvezavanje(load, OSVEZI_MS);

  const radnja = async (id: number, sta: RezervacijaRadnja) => {
    setZauzeto(true);
    try {
      await api.zabeleziRezervaciju(id, sta);
      await load();
    } catch (e) {
      setError(e instanceof Error ? e.message : String(e));
    } finally {
      setZauzeto(false);
    }
  };

  return (
    <div className="monitor">
      {error && <div className="health health--bad">{error}</div>}
      <Rezervacije pregled={pregled} onRadnja={(id, sta) => void radnja(id, sta)} zauzeto={zauzeto} />
    </div>
  );
}
